/**
 * Environment variable validation and configuration
 */

interface RequiredEnvVars {
    VITE_API_URL: string;
    VITE_API_KEY: string;
    VITE_APP_FIREBASE_API_KEY: string;
    VITE_APP_FIREBASE_AUTH_DOMAIN: string;
    VITE_APP_FIREBASE_PROJECT_ID: string;
    VITE_APP_FIREBASE_STORAGE_BUCKET: string;
    VITE_APP_FIREBASE_MESSAGE_SENDER_ID: string;
    VITE_APP_FIREBASE_APP_ID: string;
    VITE_APP_FIREBASE_VAPID_KEY: string;
}

type EnvVars = RequiredEnvVars;

export const requiredEnvVars: (keyof RequiredEnvVars)[] = ['VITE_API_URL', 'VITE_API_KEY', 'VITE_APP_FIREBASE_API_KEY', 'VITE_APP_FIREBASE_AUTH_DOMAIN', 'VITE_APP_FIREBASE_PROJECT_ID', 'VITE_APP_FIREBASE_STORAGE_BUCKET', 'VITE_APP_FIREBASE_MESSAGE_SENDER_ID', 'VITE_APP_FIREBASE_APP_ID', 'VITE_APP_FIREBASE_VAPID_KEY'];

/**
 * Validates that all required environment variables are present
 */
export function validateEnvironment(): EnvVars {
    const missingVars: string[] = [];

    for (const varName of requiredEnvVars) {
        if (!import.meta.env[varName]) {
            missingVars.push(varName);
        }
    }

    if (missingVars.length > 0) {
        throw new Error(`Missing required environment variables: ${missingVars.join(', ')}\n` + 'Please check your .env file and ensure all required variables are set.');
    }

    return import.meta.env as unknown as EnvVars;
}

/**
 * Gets environment variables with validation
 */
export function getEnvVars(): EnvVars {
    try {
        return validateEnvironment();
    } catch (error) {
        console.error('Environment validation failed:', error);
        throw error;
    }
}

/**
 * Checks if Firebase is properly configured
 */
export function isFirebaseConfigured(): boolean {
    const env = import.meta.env;
    return !!(
        env.VITE_APP_FIREBASE_API_KEY &&
        env.VITE_APP_FIREBASE_AUTH_DOMAIN &&
        env.VITE_APP_FIREBASE_PROJECT_ID &&
        env.VITE_APP_FIREBASE_STORAGE_BUCKET &&
        env.VITE_APP_FIREBASE_MESSAGE_SENDER_ID &&
        env.VITE_APP_FIREBASE_APP_ID
    );
}

